/* eslint-disable import/prefer-default-export */

export const typesOfBusiness = [
  { value: 'Sole Proprietorship', label: 'Sole Proprietorship' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'C Corporation', label: 'C Corporation' },
  { value: 'S Corporation', label: 'S Corporation' },
  { value: 'LLC', label: 'LLC' },
  { value: 'Other', label: 'Other' },
]



// WEBPACK FOOTER //
// ./src/utils/employerOptions.js